import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function Rates() {
  useSeo({
    title: "Live Gift Card Buyback Rates — 100+ Brands | GC Nexon",
    description: "See real-time payout rates for Amazon, Walmart, Target, Apple, Steam, PlayStation, and 100+ other gift card brands. Instant estimate before you submit.",
    path: "/rates",
  });
  return <WebflowPage htmlPath="/site/rates.html" title="Live rates — GC Nexon" />;
}
